import { keepPreviousData } from "@tanstack/react-query";

export const ROUTE_QUERY_STALE_TIME = 5 * 60 * 1000;
export const ROUTE_QUERY_GC_TIME = 15 * 60 * 1000;

// Re-exported from @tanstack/react-query v5 — use as: placeholderData: keepPreviousQueryData
export { keepPreviousData as keepPreviousQueryData };
